import { Select, Row, Col, Input, Button, Popconfirm, Spin, Modal, Tooltip, Typography } from 'antd';
import { CloseCircleOutlined, CheckCircleOutlined } from '@ant-design/icons';
import {  useParams } from 'react-router-dom';
import { Wrapper } from './styles';
import { useCallback, useEffect, useMemo, useState } from 'react';
import getAPPS from "../../utils/getAppAndGroups";

import { FichaService } from "../../services/ficha.service";
import { toast } from 'react-toastify';
import { DetailsUser } from '../../components/details/user';
import { DetailsAddress } from '../../components/details/address';
import { DetailsSystem } from '../../components/details/system';
import { DetailsFiles } from '../../components/details/files';
import { DetailsHigher } from '../../components/details/higher';
import { InputMatricula } from "../../components/InputMatricula";

const { Option } = Select;
const { TextArea } = Input;

export const cpfMask = (value) =>
  value
    .replace(/\D/g, "") // substitui qualquer caracter que nao seja numero por nada
    .replace(/(\d{3})(\d)/, "$1.$2") // captura 2 grupos de numero o primeiro de 3 e o segundo de 1, apos capturar o primeiro grupo ele adiciona um ponto antes do segundo grupo de numero
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d{1,2})/, "$1-$2")
    .replace(/(-\d{2})\d+?$/, "$1"); // captura 2 numeros seguidos de um traço e não deixa ser digitado mais nada

export function FormApprovalHigher() {
  const { id } = useParams();
  //const listApp = useMemo(() => getAPPS(), []);
  const [state, setState] = useState({
    cpf: "",
    nivel: null,
    observacao: null,
    matricula: null,
    nome: null,
    loading: true,
    entidade: {},
  });

  const update = useCallback((value) => {
    setState((prev) => ({ ...prev, ...value }));
  }, []);

  const loadById = useCallback(async () => {
    update({ loading: true });

    try {
      const { data } = await FichaService.getFichaSuperior(id);
      update({ loading: false, entidade: data, nivel: data.nivel });
    } catch (err) {
      console.log(err);
    } finally {
      //
    }
  }, [update, id]);

  useEffect(() => {
    loadById();
  }, [loadById]);

  const { entidade } = state;

  const validationFields = useCallback(() => {
    if (!state.nome) {
      toast.error("Preencha seu nome completo");
      return false;
    }

    if (!state.cpf) {
      toast.error("Preencha seu CPF");
      return false;
    }

    if (!state.matricula) {
      toast.error("Preencha a matricula");
      return false;
    }

   /* if (!state.nivel) {
      toast.error("Preencha o nível");
      return false;
    }*/

    if (!state.observacao) {
      toast.error("Preencha a Observação");
      return false;
    }

    return true;
  }, [state.cpf, state.matricula,state.nome, state.observacao]);
  //[state.cpf, state.matricula, state.nivel, state.nome, state.observacao]);
  const submitRequest = useCallback(
    async (isAprovado) => {
      if (validationFields()) {
        try {
          update({ loading: true });
          await FichaService.saveAprovacaoSuperior({
            id,
            nome: state.nome,
            aprovado: isAprovado,
            cpf: state.cpf,
            matricula: state.matricula,
            nivel: state.nivel,
            observacao: state.observacao,
          });
          countDown(isAprovado);
          update({
            cpf: "",
            nivel: null,
            observacao: null,
            matricula: null,
            nome: null,
            loading: true,
            entidade: {},
          });
        } catch (err) {
          toast.error("Erro ao salvar, tente novamente!");
        } finally {
          update({ loading: false });
        }
      }
    },
    [
      id,
      state.cpf,
      state.matricula,
      state.nivel,
      state.nome,
      state.observacao,
      update,
      validationFields,
    ]
  );

  function countDown(isAprovado) {
    let secondsToGo = 5;
    // \n Protocolo: ${id}
    const modal = Modal.success({
      title: `${isAprovado ? "Aprovação" : "Reprovação"} salva com sucesso`,
      content: ``,
    });
    const timer = setInterval(() => {
      secondsToGo -= 1;
      modal.update({
        content: `A modal será fechado em ${secondsToGo} segundos.`,
      });
    }, 1000);
    setTimeout(() => {
      clearInterval(timer);
      modal.destroy();
      window.location.replace("https://www.sspds.ce.gov.br");
    }, secondsToGo * 1000);
  }

  /*const dados = entidade && entidade.sistema ? listApp
  .filter(v=> v.app === entidade.sistema.replace("_", " "))[0] : [];*/

  const dados =  [];

 /* const nivelFiltered = (dados.groups || []).filter(v => v.name === state.nivel);

  const info = useCallback((texto, nivelAcesso) => {
    Modal.info({
      title: nivelAcesso,
      content: (
        <div>
          {texto}
        </div>
      ),
      onOk() {},
    });
  }, []);*/

  return (
    <Spin spinning={state.loading}>
      <Wrapper>
        <DetailsUser entidade={entidade} />
        <br />

        <DetailsAddress entidade={entidade} />
        <br />
        <DetailsSystem entidade={entidade} />
        <br />
        <DetailsHigher entidade={entidade} />
        <br />
        <DetailsFiles entidade={entidade} />
        <br />

       {/* <div className="ant-descriptions-title">Atualização Nível</div> */}

        {
        /*
        entidade && entidade.sistema && (
          
          <Row gutter={[16, 16]}>
            <Col span={2}>
              <span>Nível: </span>
            </Col>
            <Col span={6}>
              <Select
                showSearch
                placeholder="Selecione o nível"
                optionFilterProp="children"
                defaultValue={entidade.nivel}
                value={state.nivel}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
                 onChange={(nivel) => {
                  update({ nivel });
                  const helpsT = (dados.groups || []).filter(v => v.name === nivel);
                  if (helpsT && helpsT.length > 0)
                    info(helpsT[0].help, nivel);
                }}
              >
                {
                  dados.groups.map((lista) => {
                    return (
                      <Option key={lista.key} value={lista.name}>
                        {lista.name}
                      </Option>
                    );
                  })}
              </Select>
            </Col>
            {nivelFiltered && nivelFiltered.length > 0 && (
              <Tooltip title={nivelFiltered[0].help}>
                <Typography.Link
                  onClick={() => info(nivelFiltered[0].help, state.nivel)}
                >
                  Dúvida?
                </Typography.Link>
              </Tooltip>
            )}
          </Row>)
          */
          }
        <br /> 
        <Row gutter={[16, 16]}>
          <Col span={2}>
            <span>Justificativa: </span>
          </Col>
          <Col span={6}>
            <TextArea
              maxLength={1000}
              rows={4}
              value={state.observacao}
              showCount
              onChange={(e) => update({ observacao: e.target.value })}
            />
          </Col>
        </Row>
        <br />
        <br />

        <div className="ant-descriptions-title">Dados do Autorizador</div>
        <br />
        <Row gutter={[16, 16]}>
          <Col span={2}>
            <span>Matrícula: </span>
          </Col>
          <Col span={6}>
            <InputMatricula required value={state.matricula} onChange={(value) => update({ matricula: value }) } />
          </Col>
        </Row>
        <br />
        <Row gutter={[16, 16]}>
          <Col span={2}>
            <span>Nome completo: </span>
          </Col>
          <Col span={6}>
            <Input
              required
              value={state.nome}
              onChange={(e) => update({ nome: e.target.value })}
            />
          </Col>
        </Row>
        <br />
        <Row gutter={[16, 16]}>
          <Col span={2}>
            <span>CPF: </span>
          </Col>
          <Col>
            <Input
              value={state.cpf}
              onChange={(e) => update({ cpf: cpfMask(e.target.value) })}
            />
          </Col>
        </Row>
        <br />
        <br />
        <Row justify="end">
          <Col span={2} pull={2}>
            <Popconfirm
              placement="top"
              title={"Deseja realmente reprovar?"}
              onConfirm={() => submitRequest(false)}
              okText="Sim"
              cancelText="Não"
            >
              <Button icon={<CloseCircleOutlined />} danger>
                Reprovar
              </Button>
            </Popconfirm>
          </Col>
          <Col span={2} pull={1}>
            <Popconfirm
              placement="top"
              title={"Deseja realmente aprovar?"}
              onConfirm={() => submitRequest(true)}
              okText="Sim"
              cancelText="Não"
            >
              <Button icon={<CheckCircleOutlined />} type="primary">
                Aprovar
              </Button>
            </Popconfirm>
          </Col>
        </Row>
      </Wrapper>
    </Spin>
  );
}
